export default __webpack_public_path__ + "static/media/AKL.db7353c5.jpeg";